export function shareBlock() {
    const parentBlock = ".share-block";
    const button = ".share-block .button";
    const listBlock = ".share-list";
    $(document).on("click", button, function (event) {
        event.preventDefault();
        let _this = $(this);
        _this.parents(parentBlock).toggleClass("active");
        _this.parents(parentBlock).children(listBlock).stop().slideToggle(300);
    });
    $(document).mouseup(function (e) {
        if($(listBlock).is(":visible") && $(e.target).closest(parentBlock).length == 0){
            $(parentBlock).removeClass("active");
            $(listBlock).slideUp(300);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/share-block.js